package meineglasfaser.api

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import meineglasfaser.api.ubl.UBLPostalAddress
import kotlin.time.Instant

enum class CustomerType {
    INDIVIDUAL,
    COMPANY;
}

@Serializable
data class Customer(
    val id: String,
    val nid: Int,
    val type: CustomerType,
    val active: Boolean,
    val accountEmail: String,
    val accountEmailVerifiedAt: Instant? = null,
    val accountServicePIN: String,
    val individualFirstName: String? = null,
    val individualLastName: String? = null,
    val individualDob: LocalDate? = null,
    val companyName: String? = null,
    val companyVatNumber: String? = null,
    val companyContactPerson: String? = null,
    val telFixedLine: String? = null,
    val telMobile: String? = null,
    val invoicingAddress: UBLPostalAddress? = null,
    val invoicingEmail: String? = null,
    val invoicingDeliveryMode: InvoiceDeliveryMode = InvoiceDeliveryMode.EMAIL,
    val invoicingAccountHolder: String? = null,
    val invoicingIBAN: String? = null,
)

@Serializable
data class CustomerAccountInfo(
    val nid: Int,
    val type: CustomerType,
    val name: String,
    val accountEmail: String,
    val accountEmailVerified: Boolean,
    val accountServicePIN: String,
)

@Serializable
data class CustomerAccountPrincipal(
    val id: String,
    val nid: Int,
    val type: CustomerType,
    val active: Boolean,
    val accountEmail: String,
    val accountEmailVerified: Boolean,
    val accountPassword: String?,
    val accountServicePIN: String,
)

@Serializable
data class CustomerPaginated(
    val id: String,
    val nid: Int,
    val type: CustomerType,
    val active: Boolean,
    val name: String? = null,
    val invoicingAddress: UBLPostalAddress? = null,
    val companyVatNumber: String? = null,
    val email: String? = null,
    val telFixedLine: String? = null,
    val telMobile: String? = null,
)

@Serializable
data class CustomerDetailed(
    val customer: Customer,
    val orders: List<OrderWithEntries>,
)
